import React from 'react';
import { useTheme } from '../utils/theme';

const OPTIONS = [['system', 'System'], ['light', 'Light'], ['dark', 'Dark']];

const ThemeSwitch = () => {
  const { choice, setChoice } = useTheme();
  return (
    <div className="theme-switch" role="group" aria-label="Colour theme">
      {OPTIONS.map(([value, label]) => (
        <button key={value} type="button" aria-pressed={choice === value} onClick={() => setChoice(value)}>
          {label}
        </button>
      ))}
    </div>
  );
};

export default ThemeSwitch;
